export default __webpack_public_path__ + "assets/images/8e59f487a1917d2379f84b29149881ee.jpg";